
import { useAuth } from '../../contexts/AuthContext'
import { useChatContext } from '../../contexts/ChatContext'
import ChatContainer from './ChatContainer'
import ChatToggle from './ChatToggle'

/**
 * GlobalChat component that renders the chat UI.
 * Should be placed at the App level, outside of Routes.
 * Only renders when user is authenticated.
 */
export default function GlobalChat() {
  const { user, loading } = useAuth()
  const { isChatHidden } = useChatContext()

  // Don't render anything if not authenticated, still loading, or hidden by a modal
  if (loading || !user || isChatHidden) {
    return null
  }

  return (
    <>
      <ChatContainer />
      <ChatToggle />
    </>
  )
}

